/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Profile_EyebrowInputs */

const en_us2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const pt_br2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const es_419_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const pt_pt2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil`)
};

const fr_fr2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_de2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const it_it2_search_profile_eyebrow = /** @type {(inputs: Search_Profile_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Search_Profile_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_profile_eyebrow = /** @type {((inputs?: Search_Profile_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Profile_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_profile_eyebrow(inputs)
	if (locale === "es-419") return es_419_search_profile_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_search_profile_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_search_profile_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_search_profile_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_search_profile_eyebrow(inputs)
	return en_us2_search_profile_eyebrow(inputs)
});
export { search_profile_eyebrow as "search.profile_eyebrow" }